<template>
    <Toast/>
    <div class="row">
        <div class="col">
            <h2 class="titre">Modification Évaluation</h2>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :evaluation="evaluation" :listeEtats="listeEtats" :listePropos="listePropos"
                    :listeJeux="listeJeux" :liaisonsEvaluation="liaisonsEvaluation" :isModifier="true"/>
    <ButtonBar @sauvegarder="sauvegarder" @fermer="fermer" :isSauvegardeEnCours="isSauvegardeEnCours"/>
    <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import ButtonBar from '../../../components/dossier/Modifier/ButtonBarEvaluation.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsEvaluation.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
    components: {
        ButtonBar,
        ModifierChamps,
        DialogConfirmation,
    },
    data() {
        return {
            isSauvegardeEnCours: false,
        };
    },
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil',
            evaluation: 'evaluation/evaluation',
            listeEtats: 'evaluation/listeEtats',
            listePropos: 'evaluation/listePropos',
            listeJeux: 'jeux/listeJeux',
            liaisonsEvaluation: 'evaluation/liaisonMiseEvaluation'
        })
    },
    mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Modifier une Evaluation");
    },
    created() {
        setTimeout(this.afficherVerifierSauvegarde, 300000);
    },
    methods: {
        sauvegarder() {
            this.isSauvegardeEnCours = true;
            this.$store.commit('evaluation/UPDATE_EVALUATION', this.$refs.modifierChamps.getEvaluationLocal());
            this.$store.dispatch('evaluation/sauvegarderEvaluationAction', {
                cle: this.$route.params.cle,
                site: this.$route.params.site,
            }).then((res) => {
                this.$root.$refs.messagesComp.messagesList = res.data.messages
                if (res?.data?.messages.length == 0) {
                    this.$toast.add(
                            {
                                severity: 'success',
                                summary: 'Modifier',
                                detail: "L'évaluation a été modifiée.",
                                life: 6000
                            });
                }
                this.isSauvegardeEnCours = false;
            });
        },
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();
        },
        afficherVerifierSauvegarde() {
            this.$toast.add(
                    {
                        severity: 'warn',
                        summary: 'Avertissement Sauvegarde',
                        detail: "N'oubliez pas de sauvegarder régulièrement votre évaluation.",
                        life: 6000
                    });
        }
    },
    beforeRouteLeave(to, from, next) {
        return this.$refs.dialogConfirmation.confirmer(next, this.evaluation,
                this.$refs.modifierChamps.getEvaluationLocal());
    },
};
</script>
